import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@angular/flex-layout";
import { RouterModule, Routes } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { FileUploadModule } from "ng2-file-upload";
import { SnackBarService } from "#services/snackbar.service";
import { EditProfileComponent } from "./components/edit/profile-edit.component";
import { ProfileCardComponent } from "#core/profile/containers/card/profile-card.component";
import { ProfileCardStudentComponent } from "#core/profile/containers/card-student/profile-card-student.component";
import { ProfileSidePanelComponent } from "./components/side-panel/profile-side-panel.component";
import { ProfileThumbnailComponent } from "#core/profile/components/thumbnail/profile-thumbnail.component";
import { ProfileImageComponent } from "#core/profile/components/image/profile-image.component";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatTabsModule } from "@angular/material/tabs";
import { MatDividerModule } from "@angular/material/divider";
import { MatMenuModule } from "@angular/material/menu";
import { MatFormFieldModule } from "@angular/material/form-field";
import { ChangePasswordComponent } from "#core/profile/components/change-password/change-password.component";
import { ProfileMessagingContainerComponent } from "#core/components/layout-components/profile-messaging-container/profile-messaging-container.component";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatOptionModule } from "@angular/material/core";
import { MatChipsModule } from "@angular/material/chips";
import { MatBadgeModule } from "@angular/material/badge";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";

// directives
import { TrimInputDirective } from "#core/directives/trim-input/trim-input.directive";

export const ROUTES: Routes = [
    { path: "edit", component: ProfileCardComponent },
    { path: "edit-student", component: ProfileCardStudentComponent },
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(ROUTES),
        MatCardModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        MatTabsModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        FileUploadModule,
        TrimInputDirective,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatOptionModule,
        MatChipsModule,
        MatBadgeModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatTooltipModule,
    ],
    declarations: [
        EditProfileComponent,
        ProfileSidePanelComponent,
        ProfileCardComponent,
        ProfileCardStudentComponent,
        ProfileThumbnailComponent,
        ProfileImageComponent,
        ChangePasswordComponent,
        ProfileMessagingContainerComponent,
    ],
    exports: [
        ProfileSidePanelComponent,
        ProfileThumbnailComponent,
        ProfileImageComponent,
        ProfileMessagingContainerComponent,
    ],
})
export class ProfileModule {
    // to prevent duplicate instances of the ProfileModule
    static forRoot(): ModuleWithProviders<ProfileModule> {
        return {
            ngModule: ProfileModule,
            providers: [SnackBarService],
        };
    }
}
